import { gql, useQuery } from "@apollo/client";
import { Layout, PageHeader } from "antd";
import { CenterSpinner } from "components/CenterSpinner";
import { EditStocks } from "frames/stocks/EditStocks";
import React, { Fragment } from "react";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";

const articleItemQuery = gql`
  query($id: ID!) {
    articleItem(id: $id) {
      id
      season {
        id
        code
        isStock
      }
      stocks {
        id
        quantity
        size {
          id
          code
        }
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { id } = useParams();

  const variables = { id };
  const { loading, data } = useQuery(articleItemQuery, { variables, fetchPolicy: "cache-and-network" });

  if (loading) return <CenterSpinner size="large" />;

  const item = data.articleItem;
  const { season } = item;
  return (
    <Fragment>
      <PageHeader ghost={true} title="Stocks" />
      <Layout.Content className="content">
          {season.isStock && <EditStocks resource={item} />}
          {!season.isStock && (
            <span>
              No stocks for Season <NavLink to={`../../../seasons/${season.id}`}>{season.code}</NavLink>
            </span>
          )}
      </Layout.Content>
    </Fragment>
  );
};
